import React, { Component } from 'react';
import '../../../Investee/pages/Authentication/Signup.css';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet-async';
import LoginForm from './components/LoginForm';
import VerifyEmailPage from './components/VerifyEmailPage';
import {
    getApprovedState,
    getAuthenticatedState,
    getEmailVerifiedState,
    getIfUserIsInvestee,
    getIfUserIsInvestor,
    getInvesteeOrganizationInfo,
    getLoggingState,
    getPhoneNumber,
    getPhoneVerifiedState,
    getUserDetails,
    getUserProfileFetchingState,
} from '../../../App/AppReducer';
import { verifyUserEmail, resendVerifyUserEmail, logOutUser } from '../../../App/AppActions';
import PageLoader from '../../../../components/loader/PageLoader';
import { USER_TYPE_INVESTEE } from '../../../../enums/appEnums';
import LoginCarousel from './components/LoginCarousel';
import withRouter from '../../../../common/withRouter';
import VerifyEmailPhone from '../VerifyContactPage/VerifyEmailPhone';
import { isEmpty } from 'lodash';
import { RECUR_HOMEPAGE } from '../../../../constants/consts';
import { Box, Grid, Typography } from '@mui/material';
import NewLoginCarousel from './components/NewLoginCarousel';
import { getS3FLIconLink } from '../../../../util/utility';
import BgAnimationOnCompany from '../../components/BgAnimationOnCompany/BgAnimationOnCompany';

class LoginPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            user: {
                username: '',
                password: '',
            },
            isLoginSubmitted: false,
        };
    }
    componentDidMount() {
        window.scrollTo(0, 0);
        if (this.props.urlQuery && this.props.urlQuery !== '') {
            this.verifyEmailForUser(this.props.urlQuery);
        }
        if (!localStorage.getItem('incomingQueryLogin')) {
            localStorage.setItem('incomingQueryLogin', this.props.location.search);
        }
    }

    verifyEmailForUser = (query) => {
        this.props.dispatch(verifyUserEmail(query));
    };

    toggleVerifyEmail = (val) => {
        this.setState({
            isLoginSubmitted: val,
        });
    };

    resendVerifyEmail = () => {
        if (this.props.user) {
            this.props.dispatch(resendVerifyUserEmail(this.props.user.userId));
        }
    };

    handleLogoClick = () => {
        this.props.dispatch(logOutUser(this.props.navigate));
        window.location.href = RECUR_HOMEPAGE;
    };

    render() {
        if (this.props.is_fetching_user) {
            return (
                <div>
                    <PageLoader />
                </div>
            );
        }
        return (
            <Box
                sx={{
                    padding: 0,
                    margin: 'auto',
                    backgroundColor: '#00094b',
                    position: 'relative',
                    width: '100%',
                    height: '100%',
                }}
            >
                <BgAnimationOnCompany />
                <Helmet>
                    <title>{'Login | Recur Club'}</title>
                </Helmet>
                <Grid container sx={{ m: 0, height: '100vh' }}>
                    <Grid item xs={12} md={12} lg={8}>
                        <Box
                            sx={{
                                position: 'relative',
                                alignItems: 'center',
                                justifyContent: 'center',
                                height: {
                                    xs: '60%',
                                    lg: '100%',
                                },
                                flexDirection: 'column',
                            }}
                        >
                            <Box
                                sx={{
                                    zIndex: 999,
                                    position: 'absolute',
                                    top: '2.5rem',
                                    left: '2.5rem',
                                }}
                            >
                                <img
                                    src={getS3FLIconLink('recur-new-logo-3', 'svg')}
                                    onClick={this.handleLogoClick}
                                    alt="recur-logo"
                                    width={'120px'}
                                    height={'40px'}
                                    style={{
                                        cursor: 'pointer',
                                    }}
                                />
                            </Box>
                            <Box
                                sx={{
                                    display: {
                                        xs: 'none',
                                        sm: 'none',
                                        md: 'flex',
                                    },
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    flexDirection: 'column',
                                    zIndex: 99,
                                    position: 'relative',
                                    height: '100%',
                                }}
                            >
                                <Typography
                                    variant="h4"
                                    component="h2"
                                    align="center"
                                    sx={{
                                        color: '#FFF1E2',
                                        fontWeight: 400,
                                        fontSize: {
                                            md: '1.5rem',
                                            lg: '1.75rem',
                                        },
                                        margin: {
                                            md: '0 0 1rem',
                                            lg: '0rem 0 2rem',
                                        },
                                    }}
                                >
                                    Debt Capital for Startups and SMEs
                                </Typography>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                    }}
                                >
                                    <Box
                                        sx={{
                                            backgroundColor: 'transparent',
                                            borderRadius: 8,
                                            marginTop: {
                                                xs: 0,
                                            },
                                        }}
                                    >
                                        <NewLoginCarousel />
                                    </Box>
                                </Box>
                            </Box>
                        </Box>
                    </Grid>
                    {this.props.isAuthenticated ? (
                        this.props.isEmailVerified === false ? (
                            // !this.props.phoneVerified === false ||
                            // isEmpty(this.props.phoneNo) ? (
                            //     this.props.navigate('/verify', {
                            //         state: {
                            //             emailId: this.props.user.emailId,
                            //             mobileNumber: this.props.user.mobileNumber,
                            //             isEmailVerified: this.props.EmailVerified,
                            //         },
                            //     })
                            <VerifyEmailPage
                                {...this.props}
                                resendVerifyEmail={this.resendVerifyEmail}
                            />
                        ) : null
                    ) : (
                        <LoginForm
                            {...this.props}
                            toggleVerifyEmail={(val) => this.toggleVerifyEmail(val)}
                        />
                    )}
                </Grid>
            </Box>
        );
    }
}

function mapStateToProps(state, props) {
    return {
        fromState:
            props.location && props.location.state && props.location.state._refurl
                ? props.location.state._refurl
                : '',
        urlQuery: props.location.search,
        isLoggingIn: getLoggingState(state),
        user: getUserDetails(state),
        phoneVerified: getPhoneVerifiedState(state),
        isInvestee: getIfUserIsInvestee(state),
        phoneNo: getPhoneNumber(state),
        isInvestor: getIfUserIsInvestor(state),
        isAuthenticated: getAuthenticatedState(state),
        isUserApproved: getApprovedState(state),
        isEmailVerified: getEmailVerifiedState(state),
        is_fetching_user: getUserProfileFetchingState(state),
        status: getInvesteeOrganizationInfo(state)?.status,
    };
}

export default withRouter(connect(mapStateToProps)(LoginPage));
